'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = exports.defaultValues = exports.types = undefined;

var _react = require('react');

var _reactContext = require('../vendor/reactContext');

var _reactContext2 = _interopRequireDefault(_reactContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = exports.types = {
  I18n: _react.PropTypes.object
};

var defaultValues = exports.defaultValues = {
  I18n: undefined
};

var _createContext = (0, _reactContext2.default)(defaultValues),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.Consumer = Consumer;
exports.Provider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/context/i18nContext.js
// module id = 245
// module chunks = 0